import CategoryManagement from "./category-management.page";

export default CategoryManagement;
